import { RouteProp, ParamListBase } from '@react-navigation/native';

const useRoute = (): RouteProp<ParamListBase, string> => ({
    key: 'none',
    name: 'none',
    params: {},
});

export default useRoute;
